import React from 'react';
import { Container } from './styles';
import Search from '~/components/Search';
import FormDefault from '~/components/FormDefault';
import { InputText } from '~/components/NovosInputs';
import ToggleDefault from '~/components/ToggleDefault';
import Separator from '~/components/Separator';
import { CustomButtonNovo } from '~/components/Buttons/CustomButtonNovo';
import { CustomTable } from './components/CustomTable';
import { ModalSubModulos } from './components/ModalSubModulos';
import { useModulo } from './hooks/useModulo';
import { AiOutlinePlusCircle } from 'react-icons/ai';
import { HiSelector } from 'react-icons/hi';
import { OrderSubModulo } from './components/OrderSubModulo';

export const ModuloContent: React.FC = () => {
  const {
    showSearch,
    onNew,
    onRowClick,
    onSave,
    setUpdate,
    resetFormData,
    setShowSearch,
    isUpdate,
    handleDelete,
    openModal,
    formGeral,
    flgSuperAdm,
    setFlgSuperAdm,
    flgInativo,
    setFlgInativo,
    openOrderModal,
    handleOpenModal,
    handleOpenOrderModal,
  } = useModulo();

  const {
    register,
    control,
    formState: { errors },
    watch,
  } = formGeral;

  return (
    <Container>
      {showSearch && (
        <Search
          newData={onNew}
          onRowClick={onRowClick}
          codTela={183}
          orderModulo={showSearch}
        />
      )}

      {!showSearch && (
        <FormDefault
          codTela={183}
          title="Cadastro de Módulo"
          codigoRegistro={[
            {
              value: watch('cod_modulo'),
              des_campo: 'Código do Registro',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          onCancel={() => {
            resetFormData();
            setShowSearch(true);
          }}
          isUpdate={isUpdate}
          onNew={onNew}
          onDelete={handleDelete}
          onClearFields={() => resetFormData()}
          onReturnSearch={() => {
            setShowSearch(true);
            setUpdate(false);
            resetFormData();
          }}
        >
          <div className="row">
            <div className="col-sm-12 col-md-9">
              <InputText
                label="Descrição"
                name="des_modulo"
                placeholder="Informe a Descrição"
                maxLength={25}
                caseInput="upper"
                register={register}
                isError={!!errors.des_modulo}
                control={control}
              />
            </div>
            <div className="col-sm-12 col-md-2">
              <ToggleDefault
                labelText="Requer Superadmin?"
                setChecked={flgSuperAdm}
                onSwitch={() => {
                  setFlgSuperAdm(!flgSuperAdm);
                }}
              />
            </div>
            <div className="col-sm-12 col-md-1">
              <ToggleDefault
                labelText="Inativo?"
                setChecked={flgInativo}
                onSwitch={() => {
                  setFlgInativo(!flgInativo);
                }}
              />
            </div>
          </div>
          <div className="mt-4">
            <Separator labelText="Submódulos" childrenWidth="350px">
              <div
                style={{
                  display: 'flex',
                  gap: '20px',
                  justifyContent: 'flex-end',
                }}
              >
                <CustomButtonNovo
                  onClick={() => handleOpenOrderModal(true)}
                  label="Ordenar"
                  icon={HiSelector}
                />

                <CustomButtonNovo
                  onClick={() => handleOpenModal(true)}
                  variant="confirm"
                  label="Adicionar"
                  icon={AiOutlinePlusCircle}
                />
              </div>
            </Separator>
          </div>
          <div>
            <CustomTable />
          </div>
        </FormDefault>
      )}
      {openModal && <ModalSubModulos />}
      {openOrderModal && <OrderSubModulo />}
    </Container>
  );
};
